import { UPDATE_ABOUT } from './../actions/types';
import shortid from 'shortid';
const initialState = {
  abouts: [],
  about: {},
  requestFailed: false,
  requestFailedMessage: {},
  requestSuccessMessage: '',
  short_id: '',
};

export default function (state = initialState, action) {
  switch (action.type) {
    case UPDATE_ABOUT:
      if (
        (Object.keys(action.payload).length > 0 &&
          action.payload.errorMessage === '') ||
        action.payload.errorMessage === undefined
      ) {
        action.payload.processStatus = 'edit is succeeded';

        return {
          //...state,
          about: action.payload,
          //add state data
          abouts: [],
          requestFailed: false,
         // requestFailedMessage: { error: 'no' },
          requestSuccessMessage: action.payload.message,
          short_id: shortid.generate(),
          //
        };
      } else {
        return {
          //...state,
          about: [],
          requestFailed: true,
          requestFailedMessage: action.payload,
          //add state data
          abouts: [],
          requestSuccessMessage: 'error in edit question',
          short_id: shortid.generate(),
          //
        };
      }
    default:
      return state;
  }
}
